import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HeaderComp from './HeaderComp';
import FooterComp from './FooterComp';
import HomePage from '../pages/HomePage';
import HindiTypingPage from '../pages/HindiTypingPage';
import GrammarFixPage from '../pages/GrammarFixPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/CommonStyle.css';

function LayoutComp() {
	const location = useLocation();

	useEffect(() => {
		if (location.hash) {
			const el = document.querySelector(location.hash);
			if (el) el.scrollIntoView({ behavior: 'smooth' });
		} else {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}, [location]);

	return (
		<div className="container-fluid">
			<HeaderComp />
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/hindi-typing" element={<HindiTypingPage />} />
				<Route path="/grammar-fix" element={<GrammarFixPage />} />
			</Routes>
			<FooterComp />
		</div>
	);
}

export default LayoutComp;
